module.exports = __webpack_public_path__ + "img/BAY.501d0c18.png";